import { useEffect } from 'react';
import { NotificationSettings } from '@/components/settings/notification';
import { createFileRoute } from '@tanstack/react-router';
import { usePostHog } from 'posthog-js/react';

export const Route = createFileRoute('/_authenticated/_layout/settings/_layout/notification')({
  component: Notification,
});

function Notification() {
  const posthog = usePostHog();

  useEffect(() => {
    posthog?.capture('notification_settings_viewed');
  }, [posthog]);

  const handleSettingsChange = (settings: Record<string, boolean>) => {
    console.log('Settings updated:', settings);
    // Settings updated
  };

  return (
    <div className='pt-6 space-y-6'>
      <NotificationSettings onSettingsChange={handleSettingsChange} />
    </div>
  );
}
